import React, { useEffect, useState } from "react";
import "./DMCPositionList.scss";
import axios from "axios";

const DMCPositionList = () => {
  const [axiosData, setAxiosData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://sheets.googleapis.com/v4/spreadsheets/1ouRtsoahNRZJu57Ilof3ViJ41nQJ-dwUYlEHYoXrkR0/values/2:30?key=AIzaSyDw5asg8ciaDk7CWwxQHBuKD3DzKSHRZfE"
      );
      setAxiosData(response.data);
      // setLoading(false);
    };

    fetchData();
  }, []);

  const url =
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vSCWJn5gfnkDfNKKzNIS_3ylCn2vl9dxViwg_MJ_AU5DSopGjE7SO51RXE4ceNoJ4Q42Vm5L78OiLlf/pubhtml";

  //   const VesselCard = () => {
  //     axiosData?.map((data, index) => (
  //       <div className="vessel-card">
  //         <div className="vessel-card-left">
  //           <span className="kind-of-ship">{data[0]}</span>
  //           <h2 className="name-of-ship">{data[1]}</h2>
  //           <div className="ship-infos">
  //             <p className="type-of-ship">
  //               <b>Type: </b>
  //               {data[2]}
  //             </p>
  //             <p className="bhp-of-ship">
  //               <b>BHP / BP: </b>
  //               {data[3]}
  //             </p>
  //             <p className="location-of-ship">
  //               <b>Current location: </b>
  //               {data[4]}
  //             </p>

  //             <p className="location-of-ship">
  //               <b>Available: </b>
  //               {data[5]}
  //             </p>
  //           </div>

  //           <a href="#" className="request-quote">
  //             REQUEST QUOTE
  //           </a>
  //         </div>
  //         <div
  //           className="vessel-card-right"
  //           style={{
  //             background: `url(${data[6]})`,
  //           }}
  //         ></div>
  //       </div>
  //     ));
  //   };

  return (
    <div className="dmc-position-list">
      <div className="pl-container">
        {axiosData?.values.map((data, index) => (
          <div className="vessel-card" key={index}>
            <div className="vessel-card-left">
              <span className="kind-of-ship">{data[0]}</span>
              <h2 className="name-of-ship">{data[1]}</h2>
              <div className="ship-infos">
                <p className="type-of-ship">
                  <b>Type: </b>
                  {data[2]}
                </p>
                <p className="bhp-of-ship">
                  <b>BHP / BP: </b>
                  {data[3]}
                </p>
                <p className="location-of-ship">
                  <b>Current location: </b>
                  {data[4]}
                </p>

                <p className="location-of-ship">
                  <b>Available: </b>
                  {data[5]}
                </p>
              </div>
              <a
                href={`mailto:info@dutchmarinecontractors.com?subject=Quote Request for ${data[1]}&body=Hello, I would like to get a quote for the vessel ${data[1]}.`}
                className="request-quote"
                target="_blank"
                rel="noreferrer"
              >
                Request quote
              </a>
            </div>
            <div
              className="vessel-card-right"
              style={{
                background: `url(${
                  data[6] ||
                  "https://dmc.gtmstaging.com/wp-content/uploads/2023/07/home_header.webp"
                })`,
              }}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DMCPositionList;
